// extracted by mini-css-extract-plugin
export var tosLink = "_b4-0";